document.addEventListener("DOMContentLoaded", () => {
  // Function to update locale links with current handle codename
  const updateLocaleLinks = (handleCodename, forceUpdate = false) => {
    if (!window.baseHandlePath) return

    // Skip updating locale links if no handle was explicitly selected (unless forced)
    if (!forceUpdate && !window.urlCodename && !window.location.hash) return

    const languageLinks = document.querySelectorAll("a[hreflang]")
    languageLinks.forEach((link) => {
      const lang = link.getAttribute("hreflang")
      if (window.baseHandlePath[lang]) {
        const newPath = `${window.baseHandlePath[lang]}/${handleCodename}`
        link.href = newPath
      }
    })
  }

  // Get the nav menu with handle icons
  const handleNavMenu = document.querySelector(".handles .nav-menu")
  if (!handleNavMenu) {
    return
  }

  // Get all handle nav menu items and info sections
  const handleItems = handleNavMenu.querySelectorAll(".nav-menu-item")
  const handleInfoSections = document.querySelectorAll(".handles .info-section")

  if (handleItems.length === 0) {
    return
  }

  // Variable to control behavior on the first click (programmatic or user)
  let firstClick = true

  // Add click event listeners to handle items
  handleItems.forEach((item) => {
    item.addEventListener("click", function () {
      // Remove active class from all handle items
      handleItems.forEach((i) => i.classList.remove("nav-menu-item--active"))

      // Add active class to the clicked handle item
      this.classList.add("nav-menu-item--active")

      // Get the codename from the data attribute
      const handleCodename = this.getAttribute("data-codename")

      // Hide all info sections
      handleInfoSections.forEach((section) => (section.style.display = "none"))

      // Show the related info section
      const relatedSection = document.getElementById(handleCodename)
      if (relatedSection) {
        relatedSection.style.display = "flex"
      }

      if (firstClick) {
        firstClick = false
        // If this was the first click (e.g. default item loaded) and URL needs to reflect it:
        // const currentUrl = this.getAttribute('data-url');
        // if (currentUrl && !window.urlCodename && !window.location.hash) {
        //    window.history.replaceState({}, '', currentUrl);
        // }
      } else {
        const relatedSectionIcon = document.getElementById(
          handleCodename + "-icon",
        )
        if (relatedSectionIcon) {
          relatedSectionIcon.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })
        }

        // Update URL hash to reflect selected handle
        const url = this.getAttribute("data-url")
        if (url) {
          window.history.pushState({}, "", url)
          // Update locale links when handle selection changes - force update as user selected this
          updateLocaleLinks(handleCodename, true)
        }
      }
    })
  })

  // Initial activation logic:
  // window.urlCodename should be set by the Rails view from @codename
  const currentUrlCodename = window.urlCodename
  let itemToActivate = null
  let activatedByUrlPath = false
  // Track if a handle was explicitly specified in URL
  const handleSpecifiedInUrl = !!(currentUrlCodename || window.location.hash)

  if (currentUrlCodename) {
    itemToActivate = document.querySelector(
      `.nav-menu-item[data-codename="${currentUrlCodename}"]`,
    )
    if (itemToActivate) {
      activatedByUrlPath = true
    }
  }

  // Fallback to URL hash if no path codename or item not found by path codename
  if (!itemToActivate) {
    const anchor = window.location.hash
    if (anchor) {
      const hashCodename = anchor.slice(1)
      itemToActivate = document.querySelector(
        `.nav-menu-item[data-codename="${hashCodename}"]`,
      )
    }
  }

  if (itemToActivate) {
    if (activatedByUrlPath) {
      // If loaded via URL path (e.g., /handles/codename), this is not the "first default click"
      firstClick = false
    }
    // For hash-based activation, firstClick remains true, so the click won't scroll/pushState.
    // The URL will be cleaned up afterwards.
    itemToActivate.click()

    // Also update locale links when page loads with a specific handle
    const handleCodename = itemToActivate.getAttribute("data-codename")
    updateLocaleLinks(handleCodename)

    if (!activatedByUrlPath && window.location.hash) {
      // Activated by hash
      const url = itemToActivate.getAttribute("data-url")
      if (url) {
        // Update URL from hash-based to path-based without adding to history
        window.history.replaceState({}, "", url)
      }
    }
  } else if (handleItems.length > 0) {
    // If no codename in URL path or hash, activate the first handle by default.
    // firstClick is true, so this programmatic click won't scroll or pushState.
    handleItems[0].click()

    // Only update locale links if there was an explicit handle in the URL
    if (handleSpecifiedInUrl) {
      const defaultHandleCodename = handleItems[0].getAttribute("data-codename")
      updateLocaleLinks(defaultHandleCodename)
    }
  }

  // The initial display of sections is handled by the programmatic .click() calls above.
  // The old logic to hide all sections except the first is no longer needed here.
})
